export class BaseEvent {
    private _sender: any
    private _listeners: ((...args: any) => void)[]

    constructor(sender: any) {
        this._sender = sender
        this._listeners = []
    }

    public attach(listener: (...args: any) => void, highPriority?: boolean): void {
        if (!highPriority) {
            this._listeners.push(listener)
        } else {
            this._listeners.unshift(listener)
        }
    }

    public notify(args: any): void {
        for (let index = 0; index < this._listeners.length; index += 1) {
            this._listeners[index](this._sender, args)
        }
    }
}
